import React from "react";
import "../../styles/FormField.css";

interface Option {
  label: string;
  value: string;
}

interface FormFieldProps {
  label: string;
  id?: string;
  name?: string;
  type?: React.HTMLInputTypeAttribute | "select";
  value: string;
  onChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >;
  placeholder?: string;
  required?: boolean;
  min?: string;
  options?: Option[];
  className?: string;
  autoComplete?: string;
  multiline?: boolean;
  rows?: number;
  [key: string]: any;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  id,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  required,
  min,
  options,
  className,
  autoComplete,
  ...rest
}) => {
  const inputId = id || name || label.replace(/\s+/g, "-").toLowerCase();

  const today = new Date().toISOString().split("T")[0];
  const minValue = type === "date" && !min ? today : min;

  const isSelect = type === "select";

  return (
    <div className={`input-group outlined ${className || ""}`}>
      {isSelect && Array.isArray(options) ? (
        <select
          id={inputId}
          name={name || inputId}
          value={value}
          onChange={onChange as React.ChangeEventHandler<HTMLSelectElement>}
          className="input"
          required={required}
          {...rest}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={inputId}
          name={name || inputId}
          type={type as React.HTMLInputTypeAttribute}
          value={value}
          onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
          className={`input ${type === "date" ? "date-input" : ""}`}
          placeholder={placeholder}
          min={minValue}
          required={required}
          autoComplete={autoComplete}
          {...rest}
        />
      )}

      <label className="input-label" htmlFor={inputId}>
        {label}
      </label>
    </div>
  );
};

export default FormField;
